export default "__VITE_ASSET__B_q_LkjT__"